// extracted by css-extract-rspack-plugin
export default {"Container":"moFx_"};